import ReactMarkdown from 'react-markdown';
import { cn } from '@/lib/utils';

/**
 * Safe subset of markdown for assistant replies.
 */
export function MarkdownText({ content, className }: { content: string; className?: string }) {
  return (
    <div
      className={cn(
        'prose prose-sm max-w-none text-foreground prose-p:my-1 prose-ul:my-1 prose-ol:my-1 prose-li:my-0',
        'prose-headings:text-foreground prose-strong:text-foreground prose-code:rounded prose-code:bg-secondary prose-code:px-1',
        className,
      )}
    >
    <ReactMarkdown
      allowedElements={[
        'p',
        'strong',
        'em',
        'ul',
        'ol',
        'li',
        'code',
        'pre',
        'a',
        'blockquote',
      ]}
      unwrapDisallowed
      components={{
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noreferrer" className="text-accent underline">
            {children}
          </a>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
    </div>
  );
}
